const LS_ZAPI_CHAT_STORAGE = "zapi-chat-storage" as const;
const LS_CREATE_PROJECT_STORAGE = "create-project-storage" as const;
const LS_ORGANIZATION_STORAGE = "organization-storage" as const;
const LS_DIFF_STORAGE = "zapi-diff-storage" as const;
const LS_PRESENTATION_CHAT_STORAGE = "presentation-chat-storage" as const;
const LS_CHAT_ASK_STORAGE = "chat-ask-storage" as const;

const LOCAL_STORAGE_KEYS = [
  LS_ZAPI_CHAT_STORAGE,
  LS_CREATE_PROJECT_STORAGE,
  LS_ORGANIZATION_STORAGE,
  LS_DIFF_STORAGE,
  LS_PRESENTATION_CHAT_STORAGE,
  LS_CHAT_ASK_STORAGE
] as const;

export {
  LOCAL_STORAGE_KEYS,
  LS_ZAPI_CHAT_STORAGE,
  LS_CREATE_PROJECT_STORAGE,
  LS_ORGANIZATION_STORAGE,
  LS_DIFF_STORAGE,
  LS_PRESENTATION_CHAT_STORAGE,
  LS_CHAT_ASK_STORAGE
};

export type TLocalStorageKey = (typeof LOCAL_STORAGE_KEYS)[number];
